import { alpha, Theme } from '@mui/material';
import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const BET365_STYLES = {
  searchWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    width: {
      xs: '100%',
      md: '30%',
    },
    left: {
      xs: 0,
      md: '35%',
    },
    height: '100%',
    zIndex: 10,
    backgroundColor: 'primary.600',
    padding: '0 0 0 16px',
  },
  search: {
    position: 'relative',
    borderRadius: '20px',
    flexGrow: 1,
    backgroundColor: (theme: Theme) => alpha(theme.palette.common.black, 0.15),
    '&:hover': {
      backgroundColor: (theme: Theme) => alpha(theme.palette.common.black, 0.25),
    },
  },
  searchIconWrapper: {
    padding: (theme: Theme) => theme.spacing(0, 1.5),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
      typography: {
        xs: 'h4',
        md: 'h2',
      },
    },
  },
  inputBase: {
    color: 'info.300',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '10px 10px 10px 0',
      paddingLeft: 'calc(1em + 24px)',
      transition: 'width 300ms',
      typography: {
        xs: 'body3',
        md: 'inherit',
      },
    },
    '&:focus': {
      color: 'info.300',
    },
  },
  closeButton: {
    typography: 'body4',
    padding: 0,
    color: 'info.300',
    '&:hover': {
      color: 'neutral.25',
      backgroundColor: 'transparent',
    },
  },
};

const GOLA_STYLES = {
  ...BET365_STYLES,
  searchWrapper: {
    ...BET365_STYLES.searchWrapper,
    borderBottom: '3px solid',
    borderColor: 'info.main',
  },
  search: {
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchIconWrapper: {
    color: 'info.300',
    mb: -0.75,
  },
  inputBase: {
    fontSize: 18,
    color: 'info.300',
    width: '100%',
    paddingLeft: 1,
  },
};

const NEOBET_STYLES = {
  ...BET365_STYLES,
  searchWrapper: {
    ...BET365_STYLES.searchWrapper,
    width: {
      xs: '100%',
      md: 'min(560px, 42vw)',
    },
    left: {
      xs: 0,
      md: 'calc(50% - min(280px, 21vw))',
    },
    backgroundColor: 'background.paper',
    borderBottom: '1px solid',
    borderColor: 'divider',
    padding: { xs: '0 12px', md: '0 16px' },
  },
  search: {
    ...BET365_STYLES.search,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: (theme: Theme) => alpha(theme.palette.background.default, 0.88),
    '&:hover': {
      backgroundColor: (theme: Theme) => alpha(theme.palette.neutral[800], 0.92),
    },
  },
  searchIconWrapper: {
    ...BET365_STYLES.searchIconWrapper,
    color: 'neutral.400',
    '& .MuiSvgIcon-root': {
      typography: {
        xs: 'subtitle1',
        md: 'h4',
      },
    },
  },
  inputBase: {
    ...BET365_STYLES.inputBase,
    color: 'text.primary',
    '& .MuiInputBase-input': {
      ...BET365_STYLES.inputBase['& .MuiInputBase-input'],
      typography: { xs: 'body3', md: 'body2' },
      fontWeight: { xs: 600, md: 600 },
      '&::placeholder': {
        color: 'neutral.400',
        opacity: 1,
      },
    },
  },
  closeButton: {
    typography: { xs: 'body4', md: 'body3' },
    fontWeight: { xs: 700, md: 700 },
    minWidth: 40,
    minHeight: 40,
    px: 1,
    ml: 0.5,
    color: 'text.secondary',
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'primary.main',
      backgroundColor: 'transparent',
    },
  },
};

export const SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: BET365_STYLES,
  [SKIN.GOLA]: GOLA_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
